import React, { useEffect, useState } from "react";
import { Box, Divider } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CustomInput from "../../../../../Components/CustomInput";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CustomSelect from "../../../../../Components/CustomSelect";
import { useLocation } from "react-router-dom";
import DataService from "../../../../../Service";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  dialog_title: {
    marginLeft: "1.5rem",
    "& h6": {
      fontWeight: "700",
      fontSize: "18px",
    },
  },
  toggleBtn: {
    backgroundColor: "#fff",
    color: "#077F83",
    border: "1px solid #077F83",
    padding: "5px 20px",
    borderRadius: "5px 0px 0px 5px",
    "& + $toggleBtn": {
      borderRadius: "0px 5px 5px 0px",
    },

    "&.active": {
      backgroundColor: "#077F83",
      color: "#fff",
    },
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const SLAModal = (props) => {
  const { isOpen, onClose, currentRowSelection, fetchAPI, labelFlag } = props;
  const [activeMeasureMeet, setActiveMeasureMeet] = useState("");
  const [activeExceptionalCircumstance, setActiveExceptionalCircumstance] =
    useState("");
  const [dropdownValue, setDropdownValue] = useState({});
  const [textAreaValue, setTextAreaValue] = useState({});

  const classes = useStyles();
  const location = useLocation();

  const percentArray = [
    "10%",
    "20%",
    "30%",
    "40%",
    "50%",
    "60%",
    "70%",
    "80%",
    "90%",
    "100%",
  ];

  useEffect(() => {
    if (activeMeasureMeet == "false") {
      setDropdownValue({ measure_meet_percentage: "" });
    }
  }, [activeMeasureMeet]);

  useEffect(() => {
    if (activeExceptionalCircumstance == "false") {
      setTextAreaValue({ exceptions: "" });
    }
  }, [activeExceptionalCircumstance]);

  useEffect(() => {
    if (currentRowSelection) {
      setDropdownValue({
        measure_meet_percentage: currentRowSelection?.measure_meet_percentage,
      });
      setTextAreaValue({ exceptions: currentRowSelection?.exceptions });
      setActiveMeasureMeet(currentRowSelection?.measure_meet);
      setActiveExceptionalCircumstance(
        currentRowSelection?.exceptional_circumstances
      );
    }
  }, [currentRowSelection]);

  const handleDropDownValue = (event) => {
    setDropdownValue({ ...dropdownValue, [event.id]: event.value });
  };

  const handleTextAreValue = (value, id) => {
    setTextAreaValue({ ...textAreaValue, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("org_sla_id", currentRowSelection?.org_sla_id);
    formData.append("assignment_id", location?.state?.currentAssignment?.id);
    formData.append("measure_meet", activeMeasureMeet);
    formData.append(
      "measure_meet_percentage",
      dropdownValue?.measure_meet_percentage
    );
    formData.append("exceptional_circumstances", activeExceptionalCircumstance);
    formData.append("exceptions", textAreaValue?.exceptions);

    DataService.createData(formData, "create_SLA_detail")
      .then((res) => {
        if (res?.success) {
          fetchAPI();
          onClose();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.dialog_title}
        >
          {labelFlag == "editAssignmentSummary" ? "SLA" : "SLA Exceptions"}
        </DialogTitle>
        <Divider />
        {labelFlag == "editAssignmentSummary" ? (
          <DialogContent>
            <div className={classes.formWrapper}>
              <form onSubmit={handleSubmit}>
                <div>
                  <Grid
                    xs={12}
                    style={{ marginBottom: "2rem" }}
                    container
                    alignItems={"center"}
                  >
                    <Grid item xs={4}>
                      <Typography variant="h2">Did we meet measure?</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              activeMeasureMeet == "true" ? "#077F83" : "#fff",
                            color:
                              activeMeasureMeet == "true" ? "#fff" : "#077F83",
                            cursor: "pointer",
                          }}
                          onClick={() => setActiveMeasureMeet("true")}
                        >
                          Yes
                        </Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              activeMeasureMeet == "false" ? "#077F83" : "#fff",
                            color:
                              activeMeasureMeet == "false" ? "#fff" : "#077F83",
                            cursor: "pointer",
                          }}
                          onClick={() => setActiveMeasureMeet("false")}
                        >
                          No
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid
                    xs={12}
                    style={{ marginBottom: "3rem" }}
                    container
                    alignItems={"center"}
                  >
                    <Grid item xs={4}></Grid>

                    <Grid item xs={8}>
                      {activeMeasureMeet == "true" ? (
                        <CustomSelect
                          id="measure_meet_percentage"
                          name={"measure_meet_percentage"}
                          targetId={"measure_meet_percentage"}
                          labelText="Select compliance percent"
                          displayEmpty
                          variant="outlined"
                          itemArr={percentArray}
                          defaultValue={dropdownValue?.measure_meet_percentage}
                          parentcall={handleDropDownValue}
                        />
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container alignItems={"center"}>
                    <Grid item xs={4}>
                      <Typography variant="h2">
                        Were there exceptional circumstances?
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              activeExceptionalCircumstance == "true"
                                ? "#077F83"
                                : "#fff",
                            color:
                              activeExceptionalCircumstance == "true"
                                ? "#fff"
                                : "#077F83",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setActiveExceptionalCircumstance("true")
                          }
                        >
                          Yes
                        </Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              activeExceptionalCircumstance == "false"
                                ? "#077F83"
                                : "#fff",
                            color:
                              activeExceptionalCircumstance == "false"
                                ? "#fff"
                                : "#077F83",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setActiveExceptionalCircumstance("false")
                          }
                        >
                          No
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid xs={12} container alignItems={"center"}>
                    <Grid item xs={4}></Grid>

                    <Grid item xs={8}>
                      {activeExceptionalCircumstance == "true" ? (
                        <CustomInput
                          // style={{ marginTop: '24px' }}
                          id="exceptions"
                          name="exceptions"
                          targetId={"exceptions"}
                          variant="outlined"
                          placeholder="Exceptions"
                          multiline={true}
                          rows={8}
                          parentcall={handleTextAreValue}
                          value={textAreaValue?.exceptions}
                        />
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    alignItems={"center"}
                    justify={"flex-end"}
                    style={{ marginTop: 20 }}
                  >
                    <Grid item xs={2} style={{ marginRight: "1rem" }}>
                      <Button
                        disableElevation
                        type="submit"
                        style={{ textTransform: "capitalize" }}
                        onClick={onClose}
                        variant={"contained"}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        disableElevation
                        type="submit"
                        style={{ textTransform: "capitalize" }}
                        variant={"contained"}
                        color="secondary"
                      >
                        {" "}
                        Update
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </DialogContent>
        ) : (
          <>
            <DialogContent style={{ margin: "0px auto" }}>
              <div className={classes.formWrapper}>
                <Typography variant="h2" gutterBottom>
                  {currentRowSelection?.exceptions || "No data found"}
                </Typography>
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>
    </>
  );
};

export default SLAModal;
